 <div *ngIf="loadAPIcall" class="col-sm-12 padding-left-0 padding-right-5">
  <app-common-skeleton   [countforView]="7" [NameOftheScreen]="'candidateDetails'"></app-common-skeleton>
 </div>
  <div *ngIf="!loadAPIcall" class="col-sm-12 padding-left-0 padding-right-5">
    <div class="hpanel gs-cardmargin-bottom-5">
      <div class="panel-heading gs-card-headerhbuilt" >

        <label class="control-label padding-top-0 margin-bottom-5 margin-top-5"> Brief About Community </label>
        <div class="panel-tools">
          <div
            *ngIf="(values?.adminviewnavigation && communityhome?.isSuperAdmin) || (values?.adminviewnavigation && communityhome?.isAdmin)"
            class="pull-right btn-group">
            <div class="col-sm-2" title="Edit about company" (click)="editAbout(aboutTemplate)">
              <button class="edit-pencil gs-icon-btn"><span>
                  <ng-icon name="tablerPencil" class="editBG icon-over"></ng-icon>
                </span></button>
            </div>
          </div>
        </div>

      </div>

      <div class="panel-body gs-card-bodygs-card-body" style="word-wrap: break-word">
        <div *ngIf="!aboutCommunity || aboutCommunity.trim() === '<br>'">
          <p>No details have been provided here yet.</p>
        </div>

        <div *ngIf="aboutCommunity!=undefined&&aboutCommunity!=null&&aboutCommunity!=''">
          <div [ngxSummernoteView]="aboutCommunity" class="brakeCode"></div>
        </div>

      </div>
    </div>
    <div class="hpanel gs-cardmargin-bottom-5">
      <div class="panel-heading gs-card-headerhbuilt">
        <label class="control-label padding-top-0 margin-bottom-5 margin-top-5">Community Details</label>
        <div class="panel-tools">
          <div
            *ngIf="values?.adminviewnavigation && communityhome?.isSuperAdmin  ||  values?.adminviewnavigation && communityhome?.isAdmin"
            class="pull-right btn-group">
            <div class="col-sm-2" title="Edit about company" (click)="editBasic(basicTemplate)">
              <button class="edit-pencil gs-icon-btn"><span>
                  <ng-icon name="tablerPencil" class="editBG icon-over"></ng-icon>
                </span></button>
            </div>
          </div>



        </div>
      </div>

      <div class="panel-body gs-card-bodygs-card-body" style="word-wrap: break-word">
        <div class="row form-group">
          <div class="col-sm-4">Community Name</div>
          <div class="col-sm-8">{{communityName}}</div>
        </div>

        <div class="row form-group">
          <div class="col-sm-4">Tag Line</div>
          <div class="col-sm-8">
            <div *ngIf="data?.tagLine != ''">
              {{tagLine}}
            </div>
            <div *ngIf="data?.tagLine?.length == 0">
              none
            </div>
          </div>
        </div>

        <div class="row form-group">
          <div class="col-sm-4">Community Type</div>
          <div class="col-sm-8">{{communityType}}</div>
        </div>
        <div class="row form-group">
          <div class="col-sm-4">Year Started</div>
          <div class="col-sm-8">2022</div>
        </div>
        <div class="row form-group">
          <div class="col-sm-4">Members</div>
          <div class="col-sm-8">{{memberslength}}</div>
        </div>
        <div class="row form-group">
          <div class="col-sm-4">#Tags</div>
          <div class="col-sm-8" *ngIf="tags?.length != 0">{{ tags.join(', ') }}</div>
          <div class="col-sm-8" *ngIf="tags?.length == 0">None</div>
        </div>
      </div>
    </div>
    <div class="hpanel gs-cardmargin-bottom-5">
      <div class="panel-heading gs-card-headerhbuilt">
        <label class="control-label padding-top-0 margin-bottom-5 margin-top-5"> Community Guidelines</label>
        <div class="panel-tools">
          <div
            *ngIf="values?.adminviewnavigation && communityhome?.isSuperAdmin  ||  values?.adminviewnavigation && communityhome?.isAdmin"
            class="pull-right btn-group">
            <div class="col-sm-2" title="Edit about company" (click)="editGuidelined(guidelineTemplate)">
              <button class="edit-pencil gs-icon-btn"><span>
                  <ng-icon name="tablerPencil" class="editBG icon-over"></ng-icon>
                </span></button>
            </div>
          </div>
        </div>

      </div>


      <div class="panel-body gs-card-bodygs-card-body" style="word-wrap: break-word">
        <div *ngIf="guidelines === null || guidelines == undefined || guidelines =='' ">
          <p>No Community Guidelines have been provided yet.</p>
        </div>
        <div *ngIf="guidelines != null && guidelines != undefined && guidelines!=''" class="row"
          style=" padding-left: 18px;">
          <div [ngxSummernoteView]="guidelines" class="brakeCode"></div>

        </div>

      </div>
    </div>
  </div>


<ng-template #basicTemplate>
  <form [formGroup]="basicForm" class="form-horizontal">
    <div class="hpanel gs-card">

      <div class="common-header-flex">
        <div>Community Details</div>
        <button>
          <span class="common-close" (click)="modalRef.hide()">&times;</span>
        </button>
      </div>

      <div class="panel-body gs-card-bodygs-card-body">
        <div class="app-form">
          <div class="form-group row">
            <label for="communityName" class="col-sm-4 control-label required-field font-light">Community Name</label>
            <div class="col-sm-7">
              <input type="text" class="form-control input-sm" placeholder="Community Name"
                formControlName="communityName" />
              <div *ngIf="submit && basicControls.communityName.invalid || basicControls.communityName.invalid &&
                   (basicControls.communityName.dirty || basicControls.communityName.touched)" class="error-msg">
                <div *ngIf="basicControls.communityName.errors.required"> Community Name is required</div>

              </div>
              <div *ngIf="basicControls.communityName.invalid" class="error-msg">
                <div *ngIf="basicControls.communityName.errors.maxlength"> Please enter below 100 characters</div>
              </div>
            </div>
          </div>
          <div class="form-group row">
            <label for="tagLine" class="col-sm-4 control-label font-light">Tag Line</label>
            <div class="col-sm-7">
              <input type="text" class="form-control input-sm" placeholder="Tag Line" formControlName="tagLine" />
              <div *ngIf="basicControls.tagLine.invalid" class="error-msg">
                <div *ngIf="basicControls.tagLine.errors.maxlength"> Please enter below 140 characters</div>
              </div>
            </div>
          </div>

          <div class="form-group row">
            <label for="communityType" class="col-sm-4 control-label font-light">Community Type</label>
            <div class="col-sm-7">
              <div class="row" style="position: relative; top: -0.5rem;">
                <div class="col-sm-3">


                  <div class="custom-checkbox">
                    <label class="checkbox-label font-normal" style="text-align: center;"> Private
                      <input [value]="true" type="radio" formControlName="communityType" name="communityType"
                        (click)="changetype('Private',$event)">
                      <span title="Check Working Days" class="checkmark"></span>
                    </label>
                  </div>
                </div>
                <div class="col-sm-3" style="padding-left: 33px;">
                  <div class="custom-checkbox">
                    <label class="checkbox-label font-normal" style="text-align: center;"> Public
                      <input [value]="false" type="radio" formControlName="communityType" name="communityType"
                        (click)="changetype('Public',$event)">
                      <span title="Check Working Days" class="checkmark"></span>
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="form-group row">
            <label for="businessLogo" class="col-sm-4 control-label font-light">Community Logo Image</label>
            <div class="col-sm-7">
              <input accept=".jpg, .jpeg, .png" type="file" id="communityLogo"
                class="form-control  fs-file" (change)="fileChangeEvent($event,template)" #myFileInput
                (click)="myFileInput.value=null" />
              <ng-template #template>

                <div class="modal-content">

                  <div style="padding: 14px 14px !important;">
                    <label>Community Logo</label>
                    <button type="button" class="close pull-right" aria-label="Close" (click)="closeImage()">
                      <span style="font-size: 2.5rem;font-weight: 400;" aria-hidden="true">&times;</span>
                    </button>
                  </div>
                  <hr style="margin: 0px !important; padding: 0px !important">
                  <div class="modal-body">
                    <image-cropper [imageChangedEvent]="imageChangedEvent" [maintainAspectRatio]="true"
                      [aspectRatio]="2 / 2" format="jpeg" (imageCropped)="imageCropped($event)"
                      (cropperReady)="cropperReady()" (loadImageFailed)="loadImageFailed()"></image-cropper>
                  </div>
                  <div class="modal-footer trans" style="margin-top: -16px; border-radius: 5px;">
                    <div style="float: right; margin-right: 44px;">

                      <button class="btn primary-btn" (click)="imageLoaded()">Apply</button>
                    </div>
                  </div>
                </div>

              </ng-template>
            </div>
          </div>

          <div class="form-group row">
            <label for="businessLogo" class="col-sm-4 control-label font-light">Community Banner Image</label>
            <div class="col-sm-7">
              <input   accept=" .jpg, .jpeg, .png" type="file" class="form-control  fs-file"
                id="communityBanner" (change)="fileChangeEventbanner($event,templatebanner)" #myFileInput1
                (click)="myFileInput1.value=null" />
              <ng-template #templatebanner>


                <div class="modal-content">

                  <div style="padding: 14px 14px !important;">
                    <label>Community Banner</label>
                    <button type="button" class="close pull-right" aria-label="Close" (click)="closeBannerImage()">
                      <span style="font-size: 2.5rem;font-weight: 400;" aria-hidden="true">&times;</span>
                    </button>
                  </div>
                  <hr style="margin: 0px !important; padding: 0px !important">
                  <div class="modal-body">
                    <image-cropper [imageChangedEvent]="imageChangedEventbanner" [maintainAspectRatio]="true"
                      [aspectRatio]="4.5 / 1" format="jpeg" (imageCropped)="imageCroppedBanner($event)"
                      (cropperReady)="cropperReady()" (loadImageFailed)="loadImageFailed()"></image-cropper>
                  </div>
                  <div class="modal-footer trans" style="margin-top: -16px;     border-radius: 5px;">
                    <div style="float: right; margin-right: 44px;">
                      <button class="btn btn-default" (click)="closeBannerImage()">Cancel</button>
                      <button class="btn primary-btn" (click)="imageLoadedbanner()">Apply</button>
                    </div>
                  </div>
                </div>

              </ng-template>


            </div>
          </div>


          <div class="form-group row">
            <label for="tags" class="col-sm-4 control-label font-light"> #Tags</label>
            <div class="col-sm-7">

              <ng-select [isOpen]="false" [addTag]="true" [multiple]="true" maxSelectedItems="3" addTagText="Add #Tag:"
                bindLabel="name" [closeOnSelect]="true" [hideSelected]="false" placeholder="Options to add 3 #tags only"
                [(ngModel)]="tagSelectedItems" formControlName="tags">
                <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                  <div class="ng-select-checkbox-label">
                    <span class="ng-select-checkmark" [class.checked]="item$.selected"></span>
                    <span class="ng-select-checkbox-text">{{item}}</span>
                  </div>
                </ng-template>
              </ng-select>
              <label><small>Press enter to give multiple #Tags </small></label>

            </div>
          </div>
        </div>
      </div>
      <div class="text-right" style="padding-right: 64px;padding-top: 7px; padding-bottom: 7px;">
        <button type="button" class="btn btn-default" (click)="modalRef.hide()">Cancel</button>
        <button style="margin-left:2%;" type="button" class="btn primary-btn"
          (click)="updateBasic()">Submit</button>
      </div>
    </div>
  </form>
</ng-template>

<ng-template #aboutTemplate>
  <div class="hpanel gs-card">
    <div class="common-header-flex">
      <div>Brief About  Community</div>
      <button>
        <span class="common-close" (click)="closeModal()">&times;</span>
      </button>
    </div>
    <div class="panel-body gs-card-bodygs-card-body">
      <form [formGroup]="aboutForm">
            <div class="col-sm-12 R-summary">
              <div formControlName="aboutCommunity" #summernotes id="aboutCommunity" [ngxSummernote]="config2"></div>
              <div class="text-danger" *ngIf="amsubmit&&!aboutForm.controls.aboutCommunity.errors?.minchar"> Brief About Community is required</div>
              <div *ngIf="
              aboutForm.controls.aboutCommunity.invalid &&  (aboutForm.controls.aboutCommunity.dirty ||
              aboutForm.controls.aboutCommunity.touched)" class="text-danger">

                <div *ngIf="aboutForm.controls.aboutCommunity.errors.maxchar">
                  {{FORMERROR.ABOUT_YOURSELF_MAX}}
                </div>
                <!-- <div class="text-danger" *ngIf="aboutForm.controls.aboutCommunity.errors?.minchar">
                  {{FORMERROR.ABOUT_YOUR_MIN}}
                </div> -->
              </div>
              <div class="text-right" *ngIf="!aboutForm.controls.aboutCommunity.errors?.maxchar">
                <label>
                  <small>
                    <span>{{remainingCharacters}}</span>
                    Characters remaining
                  </small>
                </label>
              </div>
            </div>
      </form>
    </div>
    <div class="text-right" style="padding-top: 12px; padding-right: 41px; padding-bottom: 12px;">
      <button type="button" class="btn btn-default" (click)="closeModal()">Cancel</button>
      <button style="margin-left:2%;" type="button" id="update" class="btn primary-btn"
         (click)="updateAbout()">Submit</button>
    </div>
  </div>
</ng-template>

  <ng-template #guidelineTemplate>
    <div class="hpanel gs-card">

      <div class="common-header-flex">
        <div>Community Guidelines</div>
        <button>
          <span class="common-close" (click)="closeguidelineModal()">&times;</span>
        </button>
      </div>

      <div class="panel-body gs-card-bodygs-card-body">
        <form [formGroup]="guidelineForm">
          <div class="col-sm-12 R-summary">
            <div formControlName="communityGuidelines" #summernotes id="communityGuidelines" [ngxSummernote]="config2"></div>
            <div class="text-danger" *ngIf="amsubmit&&!guidelineForm.controls.communityGuidelines.errors?.minchar"> Community Guidelines is required</div>
            <div *ngIf="
            guidelineForm.controls.communityGuidelines.invalid &&  (guidelineForm.controls.communityGuidelines.dirty ||
            guidelineForm.controls.communityGuidelines.touched)" class="text-danger">

              <div *ngIf="guidelineForm.controls.communityGuidelines.errors.maxchar">
                {{FORMERROR.COMMUNITY_MAX}}
              </div>
              <!-- <div class="text-danger" *ngIf="guidelineForm.controls.communityGuidelines.errors?.minchar">
                {{FORMERROR.ABOUT_YOUR_MIN}}
              </div> -->
            </div>
            <div class="text-right" *ngIf="!guidelineForm.controls.communityGuidelines.errors?.maxchar">
              <label>
                <small>
                  <span>{{remainingCharacters}}</span>
                  Characters remaining
                </small>
              </label>
            </div>
          </div>
        </form>
      </div>
      <div class="text-right" style="padding-top: 12px; padding-bottom: 12px; padding-right: 41px;">
        <button type="button" class="btn btn-default" (click)="closeModal()">Cancel</button>
        <button style="margin-left:2%;" type="button" class="btn primary-btn"
          (click)="updateGuidelines()">Submit</button>
      </div>
    </div>
</ng-template>
